import type { SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import { endpoints } from "@/shared/api/endpoints";

export type ProfileSavePayload = {
	firstName: string;
	lastName: string;
	phone: string;
	email?: string;
	username?: string;
};

export type PasswordSavePayload = {
	currentPassword: string;
	newPassword: string;
	confirmPassword: string;
};

type UserProfileData = Record<string, unknown>;

export async function submitProfileSave(userId: string, payload: ProfileSavePayload) {
	const response = await apiClient
		.patch<SuccessResponse<UserProfileData>>(endpoints.users.update(userId), payload)
		.catch((error) => {
			console.error("[ProfileApi] Failed to save profile:", error);
			throw error;
		});
	return response.data.data;
}

export async function submitPasswordSave(payload: PasswordSavePayload) {
	const response = await apiClient
		.patch<SuccessResponse<{ message: string }>>(endpoints.auth.password, payload)
		.catch((error) => {
			console.error("[ProfileApi] Failed to save password:", error);
			throw error;
		});
	return response.data.data;
}
